import { AutogenModelEquipmentType, AutogenRowEquipmentType } from "./autogen/AutogenModelEquipmentType";

export class ModelEquipmentType extends AutogenModelEquipmentType<RowEquipmentType> {
    constructor() {
        super(RowEquipmentType);
    }
}

export class RowEquipmentType extends AutogenRowEquipmentType {
}